export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'match',
        count: 'recommended'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance'],
        count: ['best', 'recommended'],
    },
    link: {
        'bgg.count.notrecommended': function(rule) {

            return (rule.setting) ? rule.setting.count === 'recommended' : false

        }
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Community Player Count',
        category: 'BGG',
        description: 'Community voted player counts for the game.',
        summarise: {
            prefix: 'Community player count'
        },
        unit: 'player'
    }
}